import * as ko from "knockout";

interface IToggleAllParams<T> {
    allItems: T[]
    selectedItems: KnockoutObservableArray<T>
}

export class ToggleAll<T> {
    private readonly allItems: T[];
    private readonly indeterminate: KnockoutComputed<boolean>;
    private readonly label = `choose all`
    private readonly selectedItems: KnockoutObservableArray<T>;
    private readonly toggle: KnockoutComputed<boolean>;
    private readonly title: KnockoutComputed<string>;

    constructor(params: IToggleAllParams<T>) {
        this.allItems = params.allItems
        this.selectedItems = params.selectedItems

        this.toggle = ko.computed({
            read: () => {
                const numItems = this.selectedItems().length
                const numAll = this.allItems.length
                return numItems == numAll
            },
            write: (bool: boolean) => {
                const arr = bool ? this.allItems.slice(0) : []
                this.selectedItems(arr)
            }
        })

        this.indeterminate = ko.pureComputed(() => {
            const numSelected = this.selectedItems().length
            const numAll = this.allItems.length
            return numSelected > 0 && numSelected < numAll
        })

        this.title = ko.pureComputed<string>(() => {
            const numSelected = this.selectedItems().length
            const numAll = this.allItems.length
            return numSelected < numAll
                ? `choose all`
                : `remove all`
        })

    }

    dispose() {
        this.indeterminate.dispose()
    }

}